import { ActionType, Choice, ContentType, GraphNode, NodeType } from '../models/intentGraph.models';
import { ErrorLevel, errorMessages, ValidationModel } from '../models/validation.models';

import { _existsInNodes, _hasRaiseEventName, _isTextOrHtmlValid, _nullableExistsInNodes, _nullableOfPropType, _ofPropType } from './utils';
/** temporary check for getHelp contact support node, pass as prop for exceptions */
const specialCases: any = {
  'raiseEventName': {
    validator: _hasRaiseEventName, param: '.', breakOn: true, nodeId: ''
  }
}
export const validationSchema = () => {
  return {
    schemaVersion: {
      propertyType: 'number',
      validators: ['_ofPropType']
    },
    meta: {
      propertyType: 'object',
      validators: ['_ofPropType'],
      values: {
        id: {
          propertyType: 'string',
          validators: ['_ofPropType']
        },
        title: {
          propertyType: 'string',
          validators: ['_nullableOfPropType']
        },
        team: {
          propertyType: 'string',
          validators: ['_nullableOfPropType']
        },
        supportAreaReference: {
          propertyType: 'string',
          validators: ['_nullableOfPropType']
        }
      }
    },
    initialVariables: {
      propertyType: Array,
      validators: ['_nullableOfPropType']
    },
    topHeadingText: {
      propertyType: 'object',
      validators: ['_nullableOfPropType'],
      values: {
        contentType: {
          propertyType: ContentType,
          validators: ['_ofPropType']
        },
        content: {
          propertyType: 'string',
          validators: ['_ofPropType', '_isTextOrHtmlValid']
        }
      }
    },
    startNodeId: {
      propertyType: 'string',
      validators: ['_ofPropType', '_existsInNodes']
    },
    nodes: {
      propertyType: Array,
      validators: ['_ofPropType'],
      values: {
        textNode: {
          propertyType: 'object',
          validators: ['_notNullableObject'],
          values: {
            type: {
              propertyType: NodeType,
              validators: ['_ofPropType']
            },
            id: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            },
            name: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            },
            tags: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            },
            title: {
              propertyType: 'object',
              validators: ['_nullableOfPropType'],
              values: {
                contentType: {
                  propertyType: ContentType,
                  validators: ['_ofPropType']
                },
                content: {
                  propertyType: 'string',
                  validators: ['_ofPropType', '_isTextOrHtmlValid']
                }
              }
            },
            text: {
              propertyType: 'object',
              validators: ['_nullableOfPropType'],
              values: {
                contentType: {
                  propertyType: ContentType,
                  validators: ['_ofPropType']
                },
                content: {
                  propertyType: 'string',
                  validators: ['_ofPropType', '_isTextOrHtmlValid']
                }
              }
            },
            outcomeSignal: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            }
          }
        },
        choiceNode: {
          propertyType: 'object',
          validators: ['_notNullableObject'],
          values: {
            orderOfValidation: [
              'outcomeSignal*',
              'text*skip-2*_ofPropType',
              'question*skip-1*_ofPropType',
              'staticChoices*',
              'dynamicChoiceTargetNodeId*'
            ],
            outcomeSignal: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            },
            question: {
              propertyType: 'object',
              validators: ['_nullableOfPropType'],
              values: {
                contentType: {
                  propertyType: ContentType,
                  validators: ['_ofPropType']
                },
                content: {
                  propertyType: 'string',
                  validators: ['_ofPropType', '_isTextOrHtmlValid']
                }
              }
            },
            staticChoices: {
              propertyType: Array,
              validators: ['_nullableOfPropType'],
              values: {
                orderOfValidation: ['text*', 'raiseEventName*skip-2', 'targetNodeId*'],
                text: {
                  propertyType: 'object',
                  validators: ['_ofPropType'],
                  values: {
                    contentType: {
                      propertyType: ContentType.EmbeddedPlainText,
                      validators: ['_ofPropType']
                    },
                    content: {
                      propertyType: 'string',
                      validators: ['_ofPropType', '_isTextOrHtmlValid']
                    }
                  }
                },
                raiseEventName: {
                  propertyType: 'string',
                  validators: ['_ofPropType']
                },
                targetNodeId: {
                  propertyType: 'string',
                  validators: ['_ofPropType', '_existsInNodes']
                }
              }
            },
            dynamicChoiceTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_nullableExistsInNodes']
            }
          },
          inheritedValues: ['schemaBase.nodes.values.textNode']
        },
        dafdiagnosticnode: {
          propertyType: 'object',
          validators: ['_notNullableObject'],
          values: {
            actionType: {
              propertyType: ActionType,
              validators: ['_nullableOfPropType']
            },
            actionReference: {
              propertyType: 'string',
              validators: ['_nullableOfPropType']
            },
            parameters: {
              propertyType: 'object',
              validators: ['_nullableOfPropType']
            },
            variables: {
              propertyType: 'object',
              validators: ['_nullableOfPropType']
            },
            targets: {
              propertyType: 'object',
              validators: ['_nullableOfPropType']
            },
            defaultTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_nullableExistsInNodes']
            },
            failedTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_existsInNodes']
            }
          },
          // tslint:disable-next-line: typedef
          inheritedValues: ['schemaBase.nodes.values.textNode']
        },
        safdiagnosticnode: {
          propertyType: 'object',
          validators: ['_nullableOfPropType'],
          values: {
            payload: {
              propertyType: 'string',
              validators: ['_notNullableString']
            },
            failedTargetNodeId: {
              propertyType: 'string',
              validators: ['_ofPropType', '_existsInNodes']
            },
            successTargetNodeId: {
              propertyType: 'string',
              validators: ['_ofPropType', '_existsInNodes']
            }
          },
          // tslint:disable-next-line: typedef
          inheritedValues: ['schemaBase.nodes.values.textNode']
        },
        partnersolutionnode: {
          propertyType: 'object',
          validators: ['_nullableOfPropType'],
          values: {
            failedTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_nullableExistsInNodes']
            },
            successTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_nullableExistsInNodes']
            }
          },
          // tslint:disable-next-line: typedef
          inheritedValues: ['schemaBase.nodes.values.textNode']
        },
        inputnode: {
          propertyType: 'object',
          validators: ['_nullableOfPropType'],
          inheritedValues: ['schemaBase.nodes.values.textNode']
        },
        redirectnode: {
          propertyType: 'object',
          validators: ['_notNullableObject'],
          values:{
            type: {
              propertyType: NodeType,
              validators: ['_ofPropType']
            },
            id: {
              propertyType: 'string',
              validators: ['_ofPropType']
            },
            targetDialogId: {
              propertyType: 'string',
              validators: ['_ofPropType']
            },
            failedTargetNodeId: {
              propertyType: 'string',
              validators: ['_nullableOfPropType', '_nullableExistsInNodes']
            },
          }
        }
      }
    }
  };
};

// tslint:disable-next-line: no-any
const validationMethods: { [key: string]: any } = {
  /***
   * Param key definitions:
   *  - '.', gets the current schema object as param from intent schema
   *  - 'root.*' - you can provide the direct path the param, for example 'root.nodes' will get the nodes list from intent schema
   *  - '*' - providing '*' in param name will grab value from smapping schema and not intent schema, example '*propertyType'
   */
  _isTextOrHtmlValid: {
    method: _isTextOrHtmlValid,
    params: ['.'],
    errorMessage: 'invalid string/html format'
  },
  _existsInNodes: {
    method: _existsInNodes,
    params: ['.', 'root.nodes'],
    errorMessage: 'node id is missing in list of nodes'
  },
  _nullableExistsInNodes: {
    method: _nullableExistsInNodes,
    params: ['.', 'root.nodes'],
    errorMessage: 'node id was provided but is missing in the current list of nodes'
  },
  _ofPropType: {
    method: _ofPropType,
    params: ['.', '*propertyType'],
    errorMessage: 'encountered null value or incorrect type'
  },
  _nullableOfPropType: {
    method: _nullableOfPropType,
    params: ['.', '*propertyType'],
    errorMessage: 'encountered incorrect type'
  }
};

// tslint:disable-next-line: no-any
export const iterativelyReadDictValue = (obj: any, keys: string, delimeter: string): any => {
  let currentObj = obj;

  if (keys && obj) {
    const keysList = keys.split(delimeter);
    for (const k in keysList) {
      if (k && keysList[k]) {
        const key = keysList[k];
        if (keysList.hasOwnProperty(k)) {
          currentObj = currentObj[key];
        }
      }
    }
    return currentObj;
  }
  return null;
};

// tslint:disable-next-line: no-any
export const readParams = (
  value: object,
  params: string[] | null,
  // tslint:disable-next-line: no-any
  schemaObject: any,
  _currIntentObject: object,
  baseIntentGraphObject: object
): object[] => {
  const parameters = [];
  if (!params) {
    parameters.push(value);
  }
  if (params) {
    params.forEach((k: string) => {
      if (k === '.') {
        parameters.push(value);
      } else if (k.includes('root.')) {
        k = k.replace('root', '');
        const param = iterativelyReadDictValue(baseIntentGraphObject, k, '.');
        parameters.push(param);
      } else if (k && k.includes('*')) {
        const param = iterativelyReadDictValue(schemaObject, k, '*');
        parameters.push(param);
      } else {
        const param = iterativelyReadDictValue(value, k, '.');
        parameters.push(param);
      }
    });
  }
  return parameters;
};

const addErrorMessage = (
  errors: errorMessages,
  message: string,
  currentKey: string,
  level: ErrorLevel
): errorMessages => {
  const validationModel = new ValidationModel(message, level);
  if (errors[currentKey]) {
    errors[currentKey].push(validationModel);
  } else {
    errors[currentKey] = [validationModel];
  }
  return errors;
};

export const validateProperty = (
  errors: errorMessages,
  value: object,
  // tslint:disable-next-line: no-any
  schemaObject: any,
  currentIntentObject: object,
  currentKey: string,
  baseIntentGraphObject: object,
  validationOverrides?: string[]
): errorMessages => {
  let validators: string[] = (schemaObject && schemaObject.validators) || [];
  validators = validationOverrides && validationOverrides.length > 0 ? validationOverrides: validators;
  validators.forEach((validatorKey: string) => {
    // includes * error level warning, if it doesn't inlcude, by default we consider the error critical
    let errorLevel = ErrorLevel.critical;
    if (validatorKey.includes('*')) {
      validatorKey = validatorKey.replace('*', '');
      errorLevel = ErrorLevel.warning;
    }
    const validator = validationMethods[validatorKey];
    if (validator) {
      const vMethod = validator.method;
      const params = readParams(value, validator.params, schemaObject, currentIntentObject, baseIntentGraphObject);
      if (!vMethod(...params)) {
        const skipError = Object.keys(specialCases).find((propertyName: string)=>{
          const nodeId = specialCases[propertyName].nodeId
          return nodeId && currentKey.includes(nodeId)
        })
        if(!skipError){
          errors = addErrorMessage(errors, validator.errorMessage, currentKey, errorLevel);
        }
      }
    }
  });
  return errors;
};

// tslint:disable-next-line: no-any
export const getNodeTypeSchema = (type: NodeType, vSchema: any): any => {
  if (type) {
    switch (type.toLowerCase()) {
      case NodeType.InputNode.toLowerCase():
        return vSchema.nodes.values.inputnode;
      case NodeType.TextNode.toLowerCase():
        return vSchema.nodes.values.textNode;
      case NodeType.ChoiceNode.toLowerCase():
        return vSchema.nodes.values.choiceNode;
      case NodeType.SafDiagnosticNode.toLowerCase():
        return vSchema.nodes.values.safdiagnosticnode;
      case NodeType.PartnerSolutionNode.toLowerCase():
        return vSchema.nodes.values.partnersolutionnode;
      case NodeType.DafDiagnosticNode.toLowerCase():
        return vSchema.nodes.values.dafdiagnosticnode;
      case NodeType.RedirectNode.toLowerCase():
        return vSchema.nodes.values.redirectnode;
      default: 
        return null;
    }
  }
  return null;
};

const validateByOrder = (
  orderOfValidation: string[],
  // tslint:disable-next-line: no-any
  currIntentGraphObject: any,
  // tslint:disable-next-line: no-any
  vSchema: any,
  errors?: errorMessages,
  currentKey?: string,
  // tslint:disable-next-line: no-any
  baseIntentGraphObject?: any,
  baseKey?: string
): errorMessages => {
  /**
   * orderOfValidation example: ['text*','raiseEventName*skip-2', 'targetNodeId*'],
   */
  if (orderOfValidation) {
    const skipIndexes: number[] = [];
    const mustPass: number[] = [];
    const keysAdded: { [key: number]: string } = {};
    for (let i = 0; i < orderOfValidation.length; i++) {
      if (!skipIndexes.includes(i)) {
        const key = orderOfValidation[i];
        /**
         * if key has * validate all methods then continue to next key
         * to do- add selective method skip
         */
        const orderKey = key.split('*');
        // if current test passes/ we skip the index listed- i.e skip-2
        const skip = orderKey[1] && orderKey[1].includes('skip');
        const validationOverrideMethods = orderKey[2] || '';
        let validatorOverrides: string[] = []
        if(validationOverrideMethods){
           validatorOverrides = validationOverrideMethods.includes(',') ? validationOverrideMethods.split(',') : [validationOverrideMethods]
        }
        const propertyName = orderKey[0];
        const specialCase = specialCases[propertyName]
        if(specialCase){
          const specialPass = specialCase.validator(currIntentGraphObject[propertyName])
          if(specialPass === specialCase.breakOn){
            const nodeId =  currentKey.split(':')[1].split('.')[0]
            specialCases[propertyName].nodeId = nodeId
            return errors
          }
        }
        if (propertyName) {
          errors = validateIntentProperty(
            propertyName,
            currIntentGraphObject,
            vSchema,
            errors,
            currentKey,
            baseIntentGraphObject,
            baseKey,
            validatorOverrides
          );
          const fullKey = currentKey + propertyName;
          /**
           * if there is an error on a property that must pass, we will add all errors to global error object
           * else - we will remove the previous failure key as the next one has passed. Example: raiseEventName failed but targetNodeId passed,
           * ['text*','raiseEventName*skip-2', 'targetNodeId*']
           */

          if (mustPass.includes(i) && !errors[fullKey]) {
            /** i === skipPassIndex from previous property */
            errors[keysAdded[i]] = undefined;
            delete errors[keysAdded[i]];
          }
          /**
           * if current key passes test, then !errors[currentKey] will be undefined
           * break loop and add skipIndex
           * otherwise add key to must pass list
           */
          if (skip) {
            const skipPassIndex = skip ? parseInt(orderKey[1].replace('skip-', '')) : -1;
            if (!errors[fullKey]) {
              skipPassIndex !== -1 && skipIndexes.push(skipPassIndex);
              break;
            } else {
              keysAdded[skipPassIndex] = fullKey;
              skipPassIndex !== -1 && mustPass.push(skipPassIndex);
            }
          }
        }
      }
    }
  }
  return errors;
};

export const validateIntentSchema = (
  // tslint:disable-next-line: no-any
  currIntentGraphObject: any,
  // tslint:disable-next-line: no-any
  vSchema: any,
  errors?: errorMessages,
  currentKey?: string,
  // tslint:disable-next-line: no-any
  baseIntentGraphObject?: any
): errorMessages => {
  baseIntentGraphObject = baseIntentGraphObject || currIntentGraphObject;
  errors = errors || ({} as errorMessages);
  currentKey = currentKey || 'root.';
  const baseKey = currentKey;
  Object.keys(vSchema).forEach((k: string) => {
    errors = validateIntentProperty(
      k,
      currIntentGraphObject,
      vSchema,
      errors,
      currentKey,
      baseIntentGraphObject,
      baseKey
    );
  });
  return errors;
};

const validateIntentProperty = (
  k: string,
  // tslint:disable-next-line: no-any
  currIntentGraphObject: any,
  // tslint:disable-next-line: no-any
  vSchema: any,
  errors?: errorMessages,
  currentKey?: string,
  // tslint:disable-next-line: no-any
  baseIntentGraphObject?: any,
  baseKey?: string, 
  validationOverrides? : string[]
): errorMessages => {
  currentKey += `${k}`;
  const schemaObject = vSchema[k];
  const keyExemptions = ['nodes', 'staticChoices', 'dynamicChoices', 'propertyType', 'orderOfValidation'];
  if (!keyExemptions.includes(k)) {
    // tslint:disable-next-line: no-any
    const value: any = currIntentGraphObject[k];
    errors = validateProperty(
      errors,
      value,
      schemaObject,
      currIntentGraphObject,
      currentKey,
      baseIntentGraphObject,
      validationOverrides
    );
    if (vSchema[k].values && value) {
      currentKey += '.';
      errors = validateIntentSchema(value, vSchema[k].values, errors, currentKey, baseIntentGraphObject);
    }
  } else if (k === 'nodes') {
    const nodes: GraphNode[] = currIntentGraphObject[k];
    errors = validateProperty(
      errors,
      nodes,
      schemaObject,
      currIntentGraphObject,
      currentKey,
      baseIntentGraphObject,
      validationOverrides
    );

    if (nodes) {
      nodes.forEach((n: GraphNode, index: number) => {
        currentKey = `root.nodes[${index}].id:${n.id}`;
        const nodeTypeSchema = getNodeTypeSchema(n.type, vSchema);
        if(nodeTypeSchema){
          if (nodeTypeSchema.validators) {
            errors = validateProperty(
              errors,
              n,
              nodeTypeSchema,
              currIntentGraphObject,
              currentKey,
              baseIntentGraphObject,
              validationOverrides
            );
          }
          const values = nodeTypeSchema.inheritedValues
            ? { ...nodeTypeSchema.values, ...validationSchema().nodes.values.textNode.values }
            : nodeTypeSchema.values;
          if (values) {
            currentKey += '.';
            const orderOfValidation = values.orderOfValidation;
            errors = validateIntentSchema(n, values, errors, currentKey, baseIntentGraphObject);
            errors = validateByOrder(
              orderOfValidation,
              n,
              values,
              errors,
              currentKey,
              baseIntentGraphObject,
              baseKey
            );
          }
        }
        else{
          errors = addErrorMessage(errors, `encountered incorrect node type - ${n.type}`, currentKey, ErrorLevel.critical);
        }
      });
    }
  } else if (k === 'staticChoices') {
    const choices: Choice[] = currIntentGraphObject[k];
    errors = validateProperty(
      errors,
      choices,
      schemaObject,
      currIntentGraphObject,
      currentKey,
      baseIntentGraphObject,
      validationOverrides
    );
    const choiceSchema = schemaObject.values;
    const orderOfValidation = schemaObject.values.orderOfValidation;
    if (choices) {
      choices.forEach((c: Choice, index: number) => {
        let choiceKey = currentKey + `.staticChoices[${index}]`;
        if (choiceSchema) {
          errors = validateProperty(
            errors,
            c,
            choiceSchema,
            currIntentGraphObject,
            choiceKey,
            baseIntentGraphObject,
            validationOverrides
          );
          choiceKey += '.';
          errors = validateByOrder(
            orderOfValidation,
            c,
            choiceSchema,
            errors,
            choiceKey,
            baseIntentGraphObject,
            baseKey
          );
        }
      });
    }
  }
  currentKey = baseKey;
  return errors;
};
